module.exports = __webpack_public_path__ + "img/arrow-drop-fill.66e2f991.svg";